import type { IAuthProvider } from "./types";
import type { AuthenticationResult } from "@azure/msal-browser";
import { nativeGetToken, nativeHandleRedirectPromise, nativeLogin, nativeLogout } from "./nativeAuth";

/**
 * Native Android auth provider implementation.
 *
 * Delegates authentication to the native wrapper's MSAL bridge (window.NativeAuthProvider).
 * This provider is used when the app runs inside the native wrapper with SSO enabled.
 */
const nativeAuthProvider: IAuthProvider = {
	async login(): Promise<void> {
		try {
			await nativeLogin();
		} catch (error) {
			console.error("Native auth: login failed", error);
			throw error;
		}
	},

	async logout(): Promise<void> {
		try {
			await nativeLogout();
		} catch (error) {
			console.error("Native auth: logout failed", error);
			throw error;
		}
	},

	async getToken(scopes: string[]): Promise<AuthenticationResult> {
		try {
			return await nativeGetToken(scopes);
		} catch (error) {
			console.error("Native auth: failed to acquire token", error);
			throw error;
		}
	},

	async handleRedirectPromise(): Promise<void> {
		try {
			await nativeHandleRedirectPromise();
		} catch (error) {
			console.error("Native auth: failed to handle redirect promise", error);
			throw error;
		}
	},
};

export { nativeAuthProvider };
